
import { graphql, useStaticQuery } from 'gatsby';
import React, { useContext, useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import NetworkContext from '../context/network-context';

const query = graphql`
query CoinsQuery {
    site {
        siteMetadata {
                coins {
                    name,
                    image 
                }
            }
        }
  }`;

const useCoins = (disabledCoins) => {
    const { site } = useStaticQuery(query);
    const [coins, setCoins] = useState([]);
    useEffect(() => {
        const coins = site.siteMetadata.coins.filter(coin => {
            if (!disabledCoins) {
                return true;
            }
            const idx = disabledCoins.findIndex(disabledCoin => coin.name === disabledCoin);
            return idx === -1;
        });

        setCoins(coins);
    }, [setCoins, site, disabledCoins]);
    return coins;
};
const CoinItemSelect = ({ image, name, handleSelect }) => (
    <div role="button" onKeyPress={() => handleSelect(name)} tabIndex={0} onClick={() => handleSelect(name)} className="modal-row-item coin-item-dropdown-select align-items-center">
        <h5>{name}</h5>
        <img
            src={image}
            alt={name}
            width={60}
            height={60}
        />
    </div>);

const CoinItem = ({ image, name, handleClick, disabled }) => <div
    role="button" onKeyPress={() => handleClick()} tabIndex={0}
    onClick={handleClick} className={disabled ? "coin-select  disabled" : "coin-select"}>
    <img
        className=" mr-2"
        src={image}
        alt={name}
        width={20}
    />
    {name}
    <span className="down-caret"></span>
</div>;

function CoinSelect({ onSelect, disabledCoins, defaultSelected }) {
    const { pendingTransaction } = useContext(NetworkContext);

    const coins = useCoins(disabledCoins);

    const [selected, setSelected] = useState(null);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        if (defaultSelected && coins.length > 0) {
            setSelected(coins.find(item => item.name === defaultSelected) || coins[0]);
        }
    }, [defaultSelected, coins]);

    useEffect(() => {
        if (onSelect && selected) {
            onSelect(selected.name);
        }
    }, [selected]);

    const handleSelect = (coin) => {
        if (pendingTransaction) {
            return;
        }
        setSelected(coins.find(item => item.name === coin));
        setShow(false);
        onSelect(coin);
    };

    return (
        <>
            <CoinItem disabled={pendingTransaction} handleClick={handleShow} {...selected}  ></CoinItem>

            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                centered show={show} onHide={handleClose} >

                <Modal.Body>
                    <Container>
                        {
                            coins.map((coin, index) => <CoinItemSelect  {...coin} handleSelect={handleSelect} key={index} />)
                        }
                    </Container>
                </Modal.Body>

            </Modal>
        </>
    );
}

export default CoinSelect;
